import { render, staticRenderFns } from "./ProductInformationContent.vue?vue&type=template&id=6f1d11af&scoped=true&"
import script from "./ProductInformationContent.vue?vue&type=script&lang=js&"
export * from "./ProductInformationContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductInformationContent.vue?vue&type=style&index=0&id=6f1d11af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d11af",
  null
  
)

export default component.exports